import React, { useState, useEffect, useRef, useImperativeHandle, forwardRef } from 'react';
import { useParams } from 'react-router-dom';
import { faHeart, faTrashCan, faPenToSquare } from '@fortawesome/free-regular-svg-icons';
import { faCamera, faStar, faMagnifyingGlass, faSpinner, faFileInvoice, faUsersLine, faBan, faBook, faFloppyDisk, faCashRegister } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Alert, Button, Modal, ModalHeader, ModalBody, ModalFooter, Toast, ToastHeader, ToastBody } from 'reactstrap';
import { Html5QrcodeScanner } from 'html5-qrcode';
import useQRScan from '../useQRScan';
import moment from 'moment';
import useApiFetch from '../../ApiFetch';
import TimeFromDate from '../shared/TimeFromDate';
/*import QRScanner from './QRScanner.tsx'*/

const Scan = forwardRef((props, ref) => {
    const apiFetch = useApiFetch();
    const { eventCode } = useParams();

    const [scanModal, setScanModal] = useState(false);
    const [scannedPass, setScannedPass] = useState(null);
    const [processing, setProcessing] = useState(false);
    const [processed, setProcessed] = useState(false);
    const [message, setMessage] = useState(null);


    useImperativeHandle(ref, () => ({
        handleStartScan() {
            handleStartScan()
        }
    }));
    const qrboxFunction = function (viewfinderWidth, viewfinderHeight) {
        let minEdgePercentage = 0.8; // 70%
        let minEdgeSize = Math.min(windowSize.current[0], windowSize.current[1] - 180);
        let qrboxSize = Math.floor(minEdgeSize * minEdgePercentage);
        qrboxSize = Math.max(qrboxSize, 50);
        return {
            width: qrboxSize,
            height: qrboxSize
        };
    }

    const handleCodeScannedEvent = async (data) => {
        setProcessing(true);
        setScannedPass(null);
        await apiFetch.get('/api/event/pass?code=' + encodeURIComponent(data))
            .then(resp => {
                setScannedPass(resp.data);
                setProcessing(false);
                setProcessed(true);
            })
            .catch(ex => {
                console.log('ex', ex);
                if (ex?.response?.data?.message) {
                    setMessage(ex?.response?.data?.message);
                    if (ex?.response?.data?.pass) {
                        setScannedPass(ex?.response?.data?.pass);
                    }
                }
                setProcessing(false);
                setProcessed(true);
            }
            );

    }

    const { startQrCode, decodedQRData, stopQrCode } = useQRScan({
        qrcodeMountNodeID: "qrcodemountnode",
        getQrBoxDimension: qrboxFunction,
        codeScannedEventHandler: handleCodeScannedEvent
    });

    const toggleScanModal = () => setScanModal(!scanModal);
    const handleStartScan = () => {
        setProcessing(true);
        toggleScanModal();
        setScannedPass(null);
        if (scanModal) {
            stopQrCode();
        }
        else {
            startQrCode();
        }
        setProcessing(false);
    };

    const handleCloseModal = () => {
        try {
            stopQrCode();
        } catch { }
        setScannedPass(null);
        toggleScanModal();
    };
    const windowSize = useRef([window.innerWidth, window.innerHeight]);

    useEffect(() => {
        handleStartScan();
        //    toggleScanModal();
        //    startQrCode();
        //    //decodedQRData = {
        //    //    isScanning: false,
        //    //    isScanSuccess: true,
        //    //    isScanFailure: false,
        //    //    data: 'ba33afe4-0d0e-4a9a-959d-cc2421024ba7',
        //    //    error: "",
        //    //};
        //handleCodeScannedEvent('abe12339-a93f-4a00-b6c4-f210b562f462');
    }, []);

    return (
        <>
            <div className="card-body dash-button text-center py-5" onClick={handleStartScan}>
                <FontAwesomeIcon icon={faCamera} className="" />
            </div>
            <Modal isOpen={scanModal} toggle={handleCloseModal} fullscreen={true} fade={true}>
                <ModalHeader toggle={handleCloseModal}>
                    <FontAwesomeIcon icon={faCamera} className="pe-2" />Scan
                </ModalHeader>
                <ModalBody>
                    <div className="row justify-content-center h-100">
                        <div id="qrcodemountnode" className="col-lg-6 col-sm-11 text-center" />
                        <div className="justify-content-center align-items-center">
                            {decodedQRData && decodedQRData.isScanning ? null :
                                <>
                                    {decodedQRData && decodedQRData.isScanSuccess ?
                                        <>
                                            <div className="justify-content-center align-items-center text-center" onClick={() => {
                                                if (processing)
                                                    return;
                                                setScannedPass(null);
                                                setProcessed(false);
                                                setProcessing(false);
                                                setMessage(null);
                                                startQrCode();

                                            }}>
                                                <div className="">
                                                    <div className="col-12 col-sm-12 col-md-12 col-lg-10 col-xl-4 d-inline-block justify-content-center">
                                                        {scannedPass ?
                                                            <>
                                                                <div className="col-12 align-self-center align-items-center g-0 py-0 mb-3 shadow-lg">
                                                                    <div className="col-12 text-center">
                                                                        <img style={{ maxHeight: '200px' }} src={scannedPass?.event && scannedPass?.event.imageUrl ? scannedPass?.event.imageUrl : './assets/images/hyetech_logo2_4color.png'} className="img-fluid rounded-start rounded-end" alt="..." />
                                                                    </div>
                                                                    <div className="col-12 px-2 pt-3 text-center">
                                                                        <div className="card-body">
                                                                            <h1 className="display-2 fw-bold lh-1 mb-2" style={{ color: "#1295d8" }}>{scannedPass?.event.title}</h1>
                                                                            <p className="pt-0 small">
                                                                            </p>
                                                                            <div className="text-center py-3 px-5 mx-2 mx-sm-5">
                                                                                <h1 className="display-3 fw-bold pt-2 mb-0">
                                                                                    <span className="text-body-secondary display-6">Attendee:<br /></span>
                                                                                    {scannedPass.firstName} {scannedPass.lastName}
                                                                                </h1>
                                                                                {scannedPass.company ? <h2 className="display-4 lead">{scannedPass.company}</h2> : null}

                                                                                <p className="lead pt-5 pt-2">
                                                                                    Redeemed: <TimeFromDate date={scannedPass.redeemedDate} />
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                            :
                                                            (processing ? null : <h1>The pass scanned is invalid</h1>)
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                        :
                                        <div className="row justify-content-center align-items-center text-center">
                                            <div className="col align-self-center">
                                                <div className="card-body dash-button" onClick={() => {
                                                    if (processing)
                                                        return;
                                                    setScannedPass(null);
                                                    startQrCode();
                                                }}>
                                                    {processing ?
                                                        <FontAwesomeIcon icon={faSpinner} spin className="mb-4" style={{ paddingBottom: 0 }} />
                                                        :
                                                        <FontAwesomeIcon icon={faCamera} className="" />
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </>
                            }
                        </div>
                    </div>
                </ModalBody>
                {processed &&
                    <ModalFooter className={`${scannedPass && !message ? 'text-bg-success' : 'text-bg-danger'}`}>
                        <div className={`flex-grow-1 text-center ${scannedPass ? '' : ''}`}>
                            <span className="h1">{message ?? 'Successfully Scanned'}</span>
                        </div>
                        {/*<Button color="secondary" onClick={handleCloseModal}>*/}
                        {/*    Cancel*/}
                        {/*</Button>*/}
                    </ModalFooter>
                }
            </Modal>
        </>
    );
})
export default Scan;
